import React from "react";
import styled from "styled-components";
import { Text, buildURL, Icon } from "@thenounproject/lingo-core";

const PoweredBy = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function PoweredByLingo() {
  return (
    <PoweredBy
      href={buildURL(
        "/",
        {},
        { utm_source: "kit_footer", utm_medium: "web", utm_campaign: "powered_by_lingo" }
      )}
      className="powered-by"
      data-testid="powered-by-lingo">
      <Icon width="40" ml="6px" fill="primary" iconId="logo.full" />
      <Text
        ml="16px"
        pl="16px"
        borderLeft="1px solid primaryLightest"
        as="span"
        color="primaryLighter"
        font="ui.regular">
        Digital Asset Management
      </Text>
    </PoweredBy>
  );
}
